import React from 'react';
// import Card from '../components/Card' 
import CommitteeSection from "../../components2026/CommiteeSection";
import CommitteeMembers from '../../components2026/CommitteeMembers';

const Speakers = () => {
  const data = CommitteeMembers;

  return (
    <div className='flex flex-col'>
      <CommitteeSection id='1' title='Speakers' info={data.advisory} />
      <CommitteeSection id='1' title='Panelists' info={data.panelists} />

    </div>
  );
};

export default Speakers;
